import { useEffect } from 'react'

import { Config } from '@flowwai-frontend/bps-officer-web/env-config'

import { useUserAppConfigStore } from './stores/useUserAppConfigStore'

declare global {
   interface Window {
      clarity: any
   }
}

const useSetUserIdForMicrosoftClarity = (): void => {
   const userAppStore = useUserAppConfigStore()
   const { userDetails } = userAppStore

   const setMicrosoftClarityUserId = (): void => {
      const userId = userDetails?.userId
      if (!userId) return

      try {
         window.clarity('identify', userId)
      } catch (err) {
         console.error(err)
      }
   }

   useEffect(() => {
      setMicrosoftClarityUserId()
   }, [])
}

export { useSetUserIdForMicrosoftClarity }
